import { useState, useEffect } from "react";
import { Description, Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import references from "../data/references.json";

const AnnotationsModal = ({ isOpen, setIsOpen, question }) => {
  const [annotations, setAnnotations] = useState([]);

  useEffect(() => {
    const tmpAnnotations = references.filter((reference) => question.annotations.includes(parseInt(reference.id)));
    setAnnotations(tmpAnnotations);
  }, [question.annotations]);

  const linkify = (text) => {
    var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
    return text.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank">${url}</a>`;
    });
  };

  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      transition
      className="annotations-modal relative z-50 transition duration-300 ease-out data-[closed]:opacity-0">
      <DialogBackdrop className="fixed inset-0 bg-black/70 " />
      <div className="fixed inset-0 flex w-screen md:items-center justify-center p-4">
        <DialogPanel className="w-full max-w-2xl space-y-4 border bg-white p-4 rounded-xl overflow-hidden">
          <div className="modal-header flex justify-end">
            <button type="button" className="modal-close-btn" onClick={() => setIsOpen(false)}>
              <svg
                className="fill-neutral-200 hover:fill-white transition ease-in-out duration-150 "
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                width="30px"
                height="30px">
                <path d="M 39.486328 6.9785156 A 1.50015 1.50015 0 0 0 38.439453 7.4394531 L 24 21.878906 L 9.5605469 7.4394531 A 1.50015 1.50015 0 0 0 8.484375 6.984375 A 1.50015 1.50015 0 0 0 7.4394531 9.5605469 L 21.878906 24 L 7.4394531 38.439453 A 1.50015 1.50015 0 1 0 9.5605469 40.560547 L 24 26.121094 L 38.439453 40.560547 A 1.50015 1.50015 0 1 0 40.560547 38.439453 L 26.121094 24 L 40.560547 9.5605469 A 1.50015 1.50015 0 0 0 39.486328 6.9785156 z" />
              </svg>
            </button>
          </div>
          <div className="modal-content">
            <DialogTitle className="font-bold mt-4">Referencias</DialogTitle>
            <Description>
              {annotations.map((annotation, index) => {
                const text = `- ${linkify(annotation.text)}`;
                return <p dangerouslySetInnerHTML={{ __html: text }}></p>;
              })}
            </Description>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default AnnotationsModal;
